import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-text-align-auto-icon',
  templateUrl: './text-align-auto.component.html'
})
export class TextAlignAutoComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
